<template>
  <div>
    <PrimaryButton light @click.native="openChangeEmail" shrink>
      Change
      <v-icon class="ml-3">mdi-pencil</v-icon>
    </PrimaryButton>
    <ChangeEmailDialog :isOpen="changeEmailOpen" @close="closeChangeEmail" />
  </div>
</template>

<script>
import ChangeEmailDialog from "@/views/settings/components/dialogs/ChangeEmailDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";

export default {
  name: "ChangeEmailAction",
  components: { PrimaryButton, ChangeEmailDialog },
  data() {
    return {
      changeEmailOpen: false
    };
  },
  methods: {
    openChangeEmail() {
      this.changeEmailOpen = true;
    },
    closeChangeEmail() {
      this.changeEmailOpen = false;
    }
  }
};
</script>

<style scoped>
.v-btn {
  margin: 6px !important;
}
</style>
